export default "__VITE_ASSET__Cv8kDKW7__"